// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox-module__checkbox--osWSe","errorLabel":"Checkbox-module__errorLabel--24sXw"};